import module from '../module';

function OrderTabDeliveryModeController($scope, groupOrderService) {

    $scope.selectDelivery = async (mode) => {
        groupOrderService.setDeliveryMode(mode);
        $scope.cancelPreview();
        $scope.next();
    };
}

module.controller('OrderTabDeliveryMode', ['$scope', 'GroupOrder', OrderTabDeliveryModeController]);




// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderTabDeliveryModeController.js